module.exports = __webpack_public_path__ + "static/media/teethPreferencesPhoto.0f159690.png";